import { render, staticRenderFns } from "@/modules/Dashboard/templates/dashboard.html?vue&type=template&id=3e84fabd&scoped=true&"
import script from "@/modules/Dashboard/scripts/dashboard.ts?vue&type=script&lang=js&"
export * from "@/modules/Dashboard/scripts/dashboard.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Dashboard/styles/dashboard.scss?vue&type=style&index=0&id=3e84fabd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e84fabd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
